"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const react_intl_1 = require("react-intl");
const login2FASelector_1 = require("../selectors/login2FASelector");
const types_1 = require("../types");
const login2FAAction_1 = require("../actions/login2FAAction");
const Login2FAOneTokenStyle_1 = __importDefault(require("./styles/Login2FAOneTokenStyle"));
const transactionSigningAction_1 = require("@/features/transaction-signing/actions/transactionSigningAction");
const material_1 = require("@mui/material");
const OneToken = () => {
    const classes = (0, Login2FAOneTokenStyle_1.default)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const { layoutStatus, maskedMobileNo } = (0, react_redux_1.useSelector)(login2FASelector_1.login2FASelector);
    const handleToggleCloseOneToken = () => {
        console.log('handleToggleCloseOneToken');
        dispatch((0, login2FAAction_1.toggleCloseOneToken)());
    };
    const handleToggleResendNotification = () => {
        console.log('handleToggleResendNotification');
        dispatch((0, login2FAAction_1.toggleResendNotification)());
    };
    const handleToggleGenerateOtp = () => {
        console.log('handleToggleGenerateOtp111');
        dispatch((0, login2FAAction_1.toggleGenerateOtp)());
    };
    (0, react_1.useEffect)(() => {
        return () => {
            dispatch((0, transactionSigningAction_1.endAuthorizationStatus)());
        };
    }, []);
    return (react_1.default.createElement(material_1.Dialog, { open: layoutStatus === types_1.LayoutStatus.ONE_TOKEN || layoutStatus === types_1.LayoutStatus.ONE_TOKEN_WITH_FOOTER, classes: { paper: classes.dialog }, TransitionComponent: material_1.Slide },
        react_1.default.createElement("div", { className: classes.DialogContentOuter },
            react_1.default.createElement("div", { style: {
                    display: 'flex',
                    alignItems: 'center',
                    flexWrap: 'wrap'
                } },
                react_1.default.createElement(material_1.Typography, { className: classes.OneTokenTitle, variant: "h3" },
                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: "login-2fa-onetoken-title" })),
                react_1.default.createElement(material_1.Link, { className: classes.IconClose, onClick: handleToggleCloseOneToken })),
            react_1.default.createElement(material_1.DialogContent, null,
                react_1.default.createElement(material_1.ListItem, { className: classes.ListItem },
                    react_1.default.createElement(material_1.ListItemText, { className: classes.ListItemText },
                        react_1.default.createElement(material_1.Typography, { className: classes.typography },
                            react_1.default.createElement(react_intl_1.FormattedMessage, { id: "login-2fa-onetoken-content-1" }),
                            "(",
                            react_1.default.createElement("strong", null, maskedMobileNo),
                            ")",
                            react_1.default.createElement(react_intl_1.FormattedMessage, { id: "login-2fa-onetoken-content-1-2" })),
                        react_1.default.createElement("br", null),
                        react_1.default.createElement(material_1.Typography, { className: `${classes.note2} ${classes.typography}` },
                            react_1.default.createElement(react_intl_1.FormattedMessage, { id: "login-2fa-onetoken-content-2" })),
                        react_1.default.createElement(material_1.Link, { className: classes.Link, onClick: handleToggleResendNotification },
                            react_1.default.createElement(react_intl_1.FormattedMessage, { id: "login-2fa-onetoken-resend-notification" }))),
                    react_1.default.createElement(material_1.ListItemIcon, { className: classes.WrapIcon })),
                layoutStatus === types_1.LayoutStatus.ONE_TOKEN_WITH_FOOTER ? (react_1.default.createElement("div", { className: classes.resendNotification },
                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: "login-2fa-onetoken-footer-label" }),
                    react_1.default.createElement("a", { className: classes.OTPLink, onClick: handleToggleGenerateOtp },
                        react_1.default.createElement(react_intl_1.FormattedMessage, { id: "login-2fa-onetoken-footer-btn", values: {
                                holder: react_1.default.createElement("br", null)
                            } })))) : null))));
};
exports.default = OneToken;
